<template>
  <div>
    <basic-container>
      <div class="page-container entity-present-log-page">
        <div class="query-form-wrap">
          <el-form :inline="true" :model="searchForm" :size="formSize">
            <el-form-item>
              <el-input style="width: 350px" size="small" clearable v-model="searchForm.search"
                placeholder="UID、MAC地址、AndroID或IDFA、手机号">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-select size="small" filterable clearable v-model="searchForm.level" placeholder="风险等级">
                <el-option v-for="item in riskLevel" :key="item.id" :label="item.key" :value="item.level"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select size="small" filterable clearable v-model="searchForm.enterType" placeholder="录入方式">
                <el-option label="自动" value="1"> </el-option>
                <el-option label="手动" value="0"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button :loading="listLoading" icon="el-icon-search" type="primary" @click="doSearch"
                v-auth="'SECURITY_RISKDEVICES_SEARCH'">查询</el-button>
              <el-button type="success" plain icon="el-icon-plus" @click="showAddRiskDevice = true"
                v-auth="'SECURITY_RISKDEVICES_ADD'">新增</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-wrap">
          <avue-crud :option="options" :data="tableData" ref="crud" :page.sync="page" @refresh-change="getList"
            @on-load="getList">
            <template slot="level" slot-scope="scope">
              {{ getDeviceLRiskLevel(scope.row.level) }}
            </template>
            <template slot-scope="{row}" slot="menu">
              <el-button type="text" size="small" @click="rowLog(row)" v-auth="'SECURITY_RISKDEVICES_LOG'">
                日志
              </el-button>
              <el-button type="text" size="small" @click="viewRow(row)" v-auth="'SECURITY_RISKDEVICES_VIEW'">
                详情
              </el-button>
              <el-button type="text" size="small" @click="editRow(row)" v-auth="'SECURITY_RISKDEVICES_EDIT'">
                编辑
              </el-button>
              <el-button type="text" size="small" @click="del(row.id)" v-auth="'SECURITY_RISKDEVICES_DEL'">
                删除
              </el-button>
            </template>
          </avue-crud>
        </div>
      </div>
      <AddRiskDevices :riskLevel="riskLevel" :visible.sync="showAddRiskDevice" @reload="getList"></AddRiskDevices>
      <EditRiskDevices :riskLevel="riskLevel" :riskDevice="editRiskDeviceObj" :visible.sync="editVisible"
        @reload="getList">
      </EditRiskDevices>
      <RiskDeviceDetail :riskLevel="riskLevel" :riskDevice="editRiskDeviceObj" :visible.sync="viewVisible">
      </RiskDeviceDetail>
      <RiskDeviceLog :id="deviceId" :visible.sync="logVisible"></RiskDeviceLog>
    </basic-container>
  </div>
</template>
<script>
import { deleteRiskDevice, getRiskDevicesList } from "@/api/security/riskDevices.js";
import { getRiskLevelList } from "@/api/security/riskLevel.js";
import { merge } from "@/util/common";
import AddRiskDevices from "./components/addRiskDevices.vue";
import EditRiskDevices from "./components/editRiskDevices.vue";
import RiskDeviceDetail from "./components/riskDeviceDetail.vue";
import RiskDeviceLog from "./components/riskDeviceLog.vue";
import { riskDeviceOptions } from './risk_Option.js';

export default {
  name: "riskDevices",
  data() {
    return {
      listLoading: false,
      timeSpan: null,
      channelList: [],
      enteringStartEndDate: [],
      updateStartEndDate: [],
      searchForm: {
        search: '', // 	UID/MAC地址/android I/IDFA/手机号
        enterType: '', // 录入方式， 0 手动， 1 自动
        level: "", // 风险等级ID
        createDateBegin: "",
        createDateEnd: "",
        updateDateBegin: "",
        updateDateEnd: ""
      },
      formSize: "small",
      options: riskDeviceOptions,
      tableData: [],
      riskLevel: [],
      val: "",
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 100,
      },
      showAddRiskDevice: false,
      editVisible: false, // 编辑窗的显示
      editRiskDeviceObj: {}, // 编辑的风险设备
      viewVisible: false, // 查看的显示
      logVisible: false, // 操作日志的显示
    }
  },
  components: {
    AddRiskDevices,
    EditRiskDevices,
    RiskDeviceDetail,
    RiskDeviceLog
  },
  methods: {
    /** 删除风险设备 */
    del(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data } = await deleteRiskDevice(id);
        if (data.code === 200) {
          this.$message.success('删除成功');
          this.getList();
        }
      }).catch(() => {
        console.log('取消删除');
      });
    },
    handleCreateTimeChange(times) {
      // 录入日期开始
      if (times === null) {
        this.searchForm.createDateBegin = "";
        this.searchForm.createDateEnd = "";
      } else {
        this.searchForm.createDateBegin = times[0];
        this.searchForm.createDateEnd = times[1];
      }
    },
    handleUpdateTimeChange(times) {
      // 更新日期结束
      if (times === null) {
        this.searchForm.updateDateBegin = "";
        this.searchForm.updateDateEnd = "";
      } else {
        this.searchForm.updateDateBegin = times[0];
        this.searchForm.updateDateEnd = times[1];
      }
    },
    getLevelList() {
      const levelObj = {
        3: {
          key: '高风险',
          text: '高风险设备，会执行封禁，封禁后，应用侧无法使用相关功能'
        }, 2: {
          key: '中风险',
          text: '中风险设备，登录需要进行人脸认证登录、发端连接及投屏时触发防诈提示'
        }, 1: {
          key: '低风险',
          text: '低风险设备，发端连接及投屏时触发防诈提示'
        }, 0: {
          key: '无风险',
          text: '无风险设备，不执行相关防诈提示'
        }
      }
      getRiskLevelList({ current: 1, page: 10 }).then(res => {
        console.log(res)
        const { data, code, msg } = res.data
        if (code === 200) {
          this.riskLevel = data.records.map(item => {
            const riskObj = levelObj[item.level]
            return {
              level: item.level,
              id: item.id,
              ...riskObj
            }
          })
          console.log("🚀 ~ getRiskLevelList ~ riskLevel:", this.riskLevel)
        } else {
          this.$message.error(msg)
        }
      })
    },
    getList() {
      const query = merge({}, this.searchForm);
      query.current = this.page.currentPage
      query.size = this.page.pageSize
      this.listLoading = true;
      getRiskDevicesList(query).then(res => {
        this.listLoading = false;
        const { data, code, msg } = res.data
        if (code === 200) {
          this.tableData = data.records;
          this.page.total = data.total;
        } else {
          this.$message.error(msg)
        }
      })
    },
    doSearch() {
      // 查询列表
      this.page.currentPage = 1
      this.getList()
    },
    addForm() {
      this.editVisible = true;
    },
    forceUpdate() {
      this.$forceUpdate();
    },
    editRow(row) {
      // 编辑行
      this.editRiskDeviceObj = row
      this.editVisible = true
    },
    viewRow(row) {
      // 查看行
      this.editRiskDeviceObj = row
      this.viewVisible = true
    },
    rowLog(row) {
      // this.editRiskDeviceObj = row
      this.deviceId = row.id
      this.logVisible = true
    },
    getDeviceLRiskLevel(lid) {
      let riskObj = this.riskLevel.find(item => item.id == lid)
      return riskObj && riskObj.key
    }
  },
  created() {
    // this.getList();
    this.getLevelList()
  },
};
</script>
<style lang="scss">
.table-pagination {
  margin-top: 20px;
  text-align: right;
}

.content {
  margin-top: 20px;
  background: #f2f2f2;
  padding: 20px;

  .el-checkbox__label {
    display: inline;
  }
}
</style>
